import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { RichTextEditorComponent } from '../../components/rich-text-editor/rich-text-editor.component';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-mode-demploi-editer',
  standalone: true,
  imports: [CommonModule, FormsModule, RichTextEditorComponent],
  template: `
    <section class="mode-emploi-editor">
      <header class="editor-header">
        <h1>Éditer : {{ nomFormatted }}</h1>
      </header>
      <div class="editor-container" *ngIf="isLoaded; else loading">
        <app-rich-text-editor
          label="Contenu du mode d'emploi"
          [(ngModel)]="contenu"
          placeholder="Entrez le contenu du mode d'emploi..."
        ></app-rich-text-editor>
        <div class="actions">
          <button class="btn-save" (click)="saveModeEmploi()">Enregistrer</button>
          <button class="btn-cancel" (click)="cancel()">Annuler</button>
        </div>
        <div class="message" *ngIf="successMessage" [class.success]="true">
          {{ successMessage }}
        </div>
        <div class="message" *ngIf="errorMessage" [class.error]="true">
          {{ errorMessage }}
        </div>
      </div>
      <ng-template #loading>
        <div class="loading">Chargement...</div>
      </ng-template>
    </section>
  `,
  styles: [`
    .mode-emploi-editor {
      padding: 2rem;
      max-width: 1000px;
      margin: 0 auto;
    }

    .editor-header {
      margin-bottom: 2rem;
      border-bottom: 2px solid #73d8ff;
      padding-bottom: 1rem;
    }

    .editor-header h1 {
      margin: 0;
      color: #73d8ff;
      font-size: 2rem;
      text-transform: capitalize;
    }

    .editor-container {
      background: rgba(255, 255, 255, 0.02);
      border: 1px solid rgba(115, 216, 255, 0.2);
      border-radius: 8px;
      padding: 2rem;
    }

    .actions {
      margin-top: 2rem;
      display: flex;
      gap: 1rem;
      justify-content: flex-end;
    }

    .btn-save,
    .btn-cancel {
      padding: 0.75rem 1.5rem;
      border: none;
      border-radius: 4px;
      font-size: 1rem;
      cursor: pointer;
      transition: all 0.3s ease;
    }

    .btn-save {
      background: #73d8ff;
      color: #1a1a2e;
      font-weight: bold;
    }

    .btn-save:hover {
      background: #a0e7ff;
      transform: translateY(-2px);
    }

    .btn-cancel {
      background: rgba(255, 255, 255, 0.1);
      color: #73d8ff;
      border: 1px solid #73d8ff;
    }

    .btn-cancel:hover {
      background: rgba(255, 255, 255, 0.2);
    }

    .message {
      margin-top: 1rem;
      padding: 1rem;
      border-radius: 4px;
      text-align: center;
    }

    .message.success {
      background: rgba(76, 175, 80, 0.2);
      color: #4cb050;
      border: 1px solid rgba(76, 175, 80, 0.5);
    }

    .message.error {
      background: rgba(244, 67, 54, 0.2);
      color: #f44336;
      border: 1px solid rgba(244, 67, 54, 0.5);
    }

    .loading {
      text-align: center;
      padding: 2rem;
      color: #73d8ff;
    }
  `]
})
export class ModeDemploiEditerPage implements OnInit {
  contenu: string = '';
  nomFormatted: string = '';
  isLoaded = false;
  successMessage: string = '';
  errorMessage: string = '';
  private nom: string = '';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private http: HttpClient,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.nom = params['nom'] || '';
      this.nomFormatted = this.nom
        .split('-')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
      this.loadModeEmploi();
    });
  }

  private loadModeEmploi(): void {
    if (!this.nom) {
      this.isLoaded = true;
      this.cdr.detectChanges();
      return;
    }

    this.http
      .get<{ contenu: string }>(`${environment.apiBaseUrl}/api/mode-emploi/${this.nom}`)
      .subscribe({
        next: (response) => {
          this.contenu = response.contenu || '';
          this.isLoaded = true;
          this.cdr.detectChanges();
        },
        error: (err) => {
          console.error('Erreur lors du chargement du mode d\'emploi:', err);
          this.errorMessage = 'Impossible de charger le mode d\'emploi.';
          this.isLoaded = true;
          this.cdr.detectChanges();
        },
      });
  }

  saveModeEmploi(): void {
    if (!this.nom) {
      this.errorMessage = 'Nom du mode d\'emploi manquant.';
      this.cdr.detectChanges();
      return;
    }

    this.successMessage = '';
    this.errorMessage = '';

    this.http
      .put(
        `${environment.apiBaseUrl}/api/mode-emploi/${this.nom}`,
        { contenu: this.contenu }
      )
      .subscribe({
        next: () => {
          this.successMessage = 'Mode d\'emploi enregistré avec succès!';
          this.cdr.detectChanges();
          setTimeout(() => {
            this.router.navigate(['/intranet/mode-demploi', this.nom, 'voir']);
          }, 1500);
        },
        error: (err) => {
          console.error('Erreur lors de la sauvegarde:', err);
          this.errorMessage = err.error?.detail || 'Erreur lors de la sauvegarde.';
          this.cdr.detectChanges();
        },
      });
  }

  cancel(): void {
    this.router.navigate(['/intranet/mode-demploi', this.nom, 'voir']);
  }
}
